module.exports = __webpack_public_path__ + "img/SKMJ_standard8.33dc5afe.png";